<template>
  <div class="main">
      <h1>陕西交警缴款通知书</h1>
     <div class="head">
         <div>
             <span>业务生成日期:</span>
             <span>{{payDate}}</span>
        </div>
         <div>
             <span>缴款识别码(汇总):</span>
             <span>{{payCode}}</span>
         </div>
     </div>

      <table cellspacing="0" cellpadding="0" border="1" bordercolor="black" class="tableOne">
        <tbody>
        <tr height="28" >
            <td width="6%" rowspan="2" class="borderB center">
                执<br>收<br>单<br>位
            </td>
            <td width="15%" class="title">全 &nbsp; &nbsp; &nbsp; &nbsp;称</td>
            <td width="32%" >{{unitName}}</td>
            <td width="15%" class="title">编 &nbsp; &nbsp; &nbsp; &nbsp;码</td>
            <td width="32%">{{agencyCode}}</td>
        </tr>
        <tr height="28" >
            <td width="15%" class="borderB center">账 &nbsp; &nbsp; &nbsp; &nbsp;号</td>
            <td width=""  class="borderB">
            </td>
            <td width="15%" class="borderB center">备 &nbsp; &nbsp; &nbsp; &nbsp;注</td>
            <td width="" class="borderB"></td>
        </tr>
        </tbody>
    </table>
     <table cellspacing="0" cellpadding="0" border="1" bordercolor="black" class="tableTwo">
        <tr height="28" style="border-top:2px;">

            <td width="13%" class="center borderB" style="border-top:0px">总&nbsp;金&nbsp;额（大写）</td>
            <td width="50%" id="daxie" class="borderB borderT bold" >
                &nbsp;{{bigAmount}}
            </td>

            <td width="13%" class="borderB borderT center" >
                小 &nbsp; &nbsp;写
            </td>
            <td width="24%" class="borderB borderT bold" >
                &nbsp;￥{{amount}}&nbsp;
            </td>

        </tr>
    </table>
    <table cellspacing="0" cellpadding="0" border="1 " bordercolor="black" class="tableTree">
        <tr height="28" class="titleTh">
            <th width="24%">开票点</th>
            <th width="24%" v-if='bussinessType=="1"'>处罚决定书号</th>
            <th width="24%" v-else-if='bussinessType=="0"'>收费项目代码</th>
            <th width="">明细缴款书</th>
            <th width="24%" >金 &nbsp; &nbsp; &nbsp;额</th>
        </tr>
            <tr height="28" v-for='(item,index) in itemDetails' :key="index">
                <td class="bold center"> &nbsp; {{placeCode}}</td>
                <td class="bold center">
                        <div>
                            &nbsp;{{bookNo}}
                        </div>
                </td>
                <td class="bold">
                    <div>
                        <span>项目编号:{{item.itemCode}}</span>
                        <span style="margin-left:10px">名称:{{item.itemName}}</span>
                    </div>
                </td>
                <td  class="bold right" style="padding-right:10px">￥{{item.amt/100}}&nbsp;</td>
            </tr>
    </table> 

     <div  style="text-align: center" id="js">
        <div id="widget" class="zhew" style="margin-top: 45px;height: 300px;width: 100%;font-size:20px;">
            <div class="itembox">
                <div v-for='(item,index) in tmpList' :key="index" @click="selectPay(index)" >
                    <div :class="idx==index?'active':''">
                        <van-icon name="success" />
                    </div>
                    <img :src="item.src" alt="">
                </div>
            </div>
            <div class="btn" @click="pay">确认支付</div>
        </div>
    </div>  

    <div class="model" v-if='showModel'></div>
    <div class="notice" :class="showModel?'show':''">
        <div class="title">
            <span>提示</span>
            <van-icon name="cross" class="icon"  @click="closeNotice"/>
        </div>
        <div class="content">{{noticeContent}}</div>
        <div class="foot">
            <div class="sure" @click="closeNotice">确定</div>
        </div>
    </div>
</div>
</template>
 
<script>
import { Dialog } from 'vant';
export default {
    data() {
        return {
            agencyCode:'',
            unitName:'',
            payDate:'',
            bookNo:'',
            placeCode:'',
            payCode:'',
            bigAmount:'',
            itemDetails:[],
            amount:'',
            merchantNo:'',
            bussinessType:'',
            widget_content:'',
            widget_data:'',
            thirdpayDomain:'',
            channelList:[],
            tmpList:[],
            radio:'',
            idx:-1,
            paytype:'',
            channelCode:'',
            paytypeName:'',
            areaCode:'',
            url:'',
            showModel:false,
            noticeContent:''
        }
    },
    created(){
        this.getPayInfo();
    },
    methods:{
        getPayInfo(){
            let data = {
                payCode:this.$route.query.payCode,
                payName:this.$route.query.payName,
                widget_content:this.$route.query.widget_content,
                amount:this.$route.query.amount,
                deviceType:this.$route.query.deviceType
            }
            this.request({
                baseURL: process.env.VUE_APP_PAY_URL,
                url:'/tc_api/payInfo',
                method:'post',
                data:data
            }).then((res)=>{
                if(res.data.code == 1000){
                    this.agencyCode = res.data.result.agencyCode;
                    this.unitName = res.data.result.unitName;
                    this.payDate = res.data.result.payDate;
                    this.payCode = res.data.result.payCode;
                    this.bigAmount = res.data.result.bigAmount;
                    this.bussinessType = res.data.result.bussinessType;
                    this.bookNo = res.data.result.bookNo;
                    this.itemDetails = res.data.result.paramList.itemDetails
                    this.placeCode = res.data.result.paramList.placeCode
                    this.amount = res.data.result.amount;
                    this.merchantNo = res.data.result.merchant_no;
                    this.widget_content = res.data.result.widget_content;
                    this.widget_data = res.data.result.widget_data;
                    this.thirdpayDomain = res.data.result.thirdpayDomain;
                    this.areaCode = res.data.result.areaCode;
                    this.url = res.data.result.thirdpayUrl;
                    this.payLoad()
                }
            })
        },
        payLoad() {
            var dataAll=JSON.parse(this.widget_content);
            var merchant_no=dataAll.merchant_no;
            var deviceType=dataAll.device_type;
            var url=this.thirdpayDomain+'/thirdpay/widget/getConfigParam.do';
            var authCode = "";
            var widgetType = "";
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                crossDomain: true,
                cache: false,
                data: {"merchantNo": merchant_no, "deviceType": 'pc', "widgetType": widgetType, "authCode": authCode},
                success: (msg)=> {
                    jQuery.support.cors = true;
                    var jsName = msg.js;
                    var channelList = msg.channelList;
                    this.widgetShow(dataAll, channelList);
                },
                error: function (p1, p2, p3) {
                    this.showModel = true
                    this.noticeContent = JSON.stringify(p1)
                }
            });
        },
        widgetShow(data, channelList) {
            var flag = false;
            var num = 1;
            var loop = channelList.length;    //循环次数
            //用于区别是否为致新支付生单挂件
            for (var i = 0; i < loop; i++) {
                if (channelList[i].fcode == "THIRDPAY_FSSD") {
                    flag = true;
                    channelList.splice(i,1);
                    i = i - 1;    //改变循环变量
                    loop = loop - num;   //改变循环次数
                }
            }
            //查询支付渠道中包含招行非税渠道,有的话,拆分为招行微信与招行阿里
            var tmpList = JSON.parse(JSON.stringify(channelList));
            for(var i=0;i<channelList.length;i++) {
                var pay1= JSON.parse(JSON.stringify(channelList[i]));
                var pay2=JSON.parse(JSON.stringify(channelList[i]));
                if(channelList[i].fcode=="CMB_NONTAX"){
                    tmpList.splice(i,1);
                    pay1.fname="微信";
                    tmpList.push(pay1);
                    pay2.fname="支付宝";
                    tmpList.push(pay2);
                }
            }
            tmpList.forEach(item => {
                if (item.fcode == "WXPAY_NONTAX_PC") {
                    item.src = require('@/assets/img/wxpay.png')
                }else if (item.fcode == "ALIPAYFORPAGE") {
                    item.src = require('@/assets/img/alipay.png')
                }else if (item.fcode == "UNIONPAY") {
                    item.src = require('@/assets/img/unionpay.png')
                }
            });
            this.tmpList = tmpList 
        },
        selectPay(index) {
            this.idx = index
            this.paytype = this.tmpList[index].fid
            this.channelCode = this.tmpList[index].fcode
            this.paytypeName = this.tmpList[index].fname
        },
        pay() {
            if (this.channelCode && this.paytype) {
                $.ajax({
                    type: 'post',
                    url: this.url,
                    data: {
                        'paytype': this.paytype,
                        'channelCode':this.channelCode,
                        'merchantNo': this.merchantNo,
                        'paytypeName':this.paytypeName,
                        'amt':this.amount,
                        'paycode':this.payCode,
                        'transprotParam':this.widget_content,
                        'placeCode':this.areaCode
                    },
                    success: (data)=> {
                        var result = JSON.parse(data);
                        if (result.success){
                            var res = result.extraInfo;
                            document.write(res);
                        }else{
                            this.noticeContent = result.msg
                            this.showModel = true
                        }
                    }
                });
            }else {
                this.showModel = true
                this.noticeContent = '请选择支付方式'
            }
        },
        // 关闭提示
        closeNotice() {
            this.showModel = false
        }
    }
}
</script>

<style lang='scss' scoped>
.main {
    padding: 10px 0;
    margin: 0 20px;
    h1 {
        text-align: center;
        font-size: 8px;
        margin-bottom: 5px;
    }
    .head {
        padding-right: 80px;
        display: flex;
        justify-content: space-between;
        font-size: 5px;
        margin-bottom: 2px;
        >div > span:nth-of-type(2) {
            margin-left: 5px;
        }
        >div:nth-of-type(2) {
            >span:nth-of-type(2) {
                font-weight: bold;
            }
        }
    }
    .tableOne {
        width: 100%;
        font-size: 5px;
        td {
            height: 14px;
            font-family: "楷体"!important;
        }
        .title {
            text-align: center;
        }
    }
    .tableTwo {
        width: 100%;
        font-size: 5px;
         td {
            height: 14px;
            font-family: "楷体"!important;
        }
    }
    .tableTree {
        width: 100%;
        font-size: 5px;
         td {
            height: 14px;
            font-family: "楷体"!important;
        }
        th {
            text-align: center;
            border-top: 0px;
        }
        .titleTh {
            border-top:2px;
            background-color: #19a7f0;
            color:white;
        }
    }
}
.borderB {
    border-bottom:1px;
}
.borderT {
    border-top: 1px;
}
.center {
    text-align: center;
}
.bold {
    font-weight: bold;
}
.right {
    text-align: right;
}
.itembox  {
    width: 60%;
    display: flex;
    justify-content: space-between;
    >div {
        display: flex;
        align-items: center;
        cursor: pointer;
        >div {
            width: 8px;
            height: 8px;
            border: 0.3px solid #c8c9cc;
            border-radius: 50%;
            box-sizing: border-box;
            color: transparent;
            text-align: center;
            line-height: 8px;
            .van-icon {
                font-size: 8px;
            }
            &.active {
                border: none;
                background: #1989fa;
                color: #fff;
            }
        }
        >img {
            border: 0.1px solid #000;
            margin-left: 2px;
        }
    }
}
.btn {
    float: right;
    background: #4fa1e0;
    color: #fff;
    width: 30px;
    height: 10px;
    line-height: 10px;
    font-size: 5px;
    border-radius: 1px;
    cursor: pointer;
    margin-top: 10px !important;
}
.model {
    width: 100vw;
    height: 100vh;
    background: #000;
    position: fixed;
    left: 0;
    top: 0;
    opacity: 0.3;
}
.notice {
    width:100px;
    box-sizing: border-box;
    background: #fff;
    position: fixed;
    left: 50%;
    margin-left: -30px;
    top: -100%;
    margin-top: -15px;
    border-radius: 2px;
    padding: 4px;
    transition: all .8s;
    &.show {
         top: 40%;
    }
    .title {
        height: 8px;
        font-size: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;
        .icon {
            cursor: pointer;
        }
    }
    .content {
        color: #000;
        padding: 10px 5px;
        font-size: 5px;
    }
    .foot {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 7px;
        .sure {
            background: #4fa1e0;
            color: #fff;
            width: 20px;
            height: 10px;
            line-height: 10px;
            font-size: 5px;
            border-radius: 1px;
            cursor: pointer;
            position: sticky;
        }
    }
}
</style>